import { Component, input, output } from '@angular/core';
import { ContractConditions } from '../../model/contract-conditions.model';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  imports: [
    NgSelectComponent,
    FormsModule,
    NgSelectModule
  ],
  styleUrls: ['./contract.component.scss']
})
export class ContractComponent {
  conditions = input.required<ContractConditions[]>();
  contractSelectedEvent = output<ContractConditions>();

  selectContract(contract: ContractConditions): void {
    this.contractSelectedEvent.emit(contract);
  }

  customSearchFn(term: string, item: any): boolean {
    term = term.toLowerCase();
    return (item.contractName?.toLowerCase().includes(term) || item.contractId?.toLowerCase().includes(term));
  }
}
